var exports = {
  "wx": "x234b8571--84bfe7--header",
  "wm": "x234b8571--84bfe7--logo",
  "DD": "x234b8571--84bfe7--title",
};

module.exports = exports;
